import React from "react";
import Icon from "../../../components/AppIcon";

const SummaryCard = ({
  title,
  amount,
  subtitle,
  icon,
  iconColor,
  trend,
  trendDirection,
}) => {
  const getTrendIcon = () => {
    if (trendDirection === "up") return "TrendingUp";
    if (trendDirection === "down") return "TrendingDown";
    return "Minus";
  };

  const getTrendColor = () => {
    if (trendDirection === "up") return "text-success";
    if (trendDirection === "down") return "text-error";
    return "text-muted-foreground";
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 lg:p-8 hover-lift transition-base h-full flex flex-col">
      <div className="flex items-start justify-between mb-3 md:mb-4 flex-1">
        <div className="flex-1">
          <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1 md:mb-2">
            {title}
          </p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
            {amount}
          </h3>
        </div>
        <div
          className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ background: `${iconColor}15` }}
        >
          <Icon
            name={icon}
            size={20}
            color={iconColor}
            className="md:w-6 md:h-6 lg:w-7 lg:h-7"
          />
        </div>
      </div>

      <div className="flex items-center justify-between">
        <p className="text-xs md:text-sm font-caption text-muted-foreground">
          {subtitle}
        </p>
        {trend && (
          <div className={`flex items-center gap-1 ${getTrendColor()}`}>
            <Icon name={getTrendIcon()} size={14} className="md:w-4 md:h-4" />
            <span className="text-xs md:text-sm font-caption font-semibold">
              {trend}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SummaryCard;
